// Language code references: https://www.andiamo.co.uk/resources/iso-language-codes
export const LanguageList = [
  { value: '', label: 'Default', code: '', nativeName: '' },
  { value: 'en', label: 'English', code: 'en', nativeName: 'English' },
  {
    value: 'en_GB',
    label: 'English (United Kingdom)',
    code: 'en_GB',
    nativeName: 'English (United Kingdom)'
  },

  { value: 'bs_BA', code: 'bs_BA', label: 'Bosnian', nativeName: 'Bosnian' },
  {
    value: 'zh_CN',
    code: 'zh_CN',
    label: 'Chinese (Simplified)',
    nativeName: 'Simplified Chinese'
  },
  {
    value: 'zh_Hans_HK',
    code: 'zh_Hans_HK',
    label: 'Chinese (Simplified, Hong Kong)',
    nativeName: 'Chinese Hong Kong'
  },
  { value: 'hr', code: 'hr', label: 'Croatian', nativeName: 'Croatian' },
  { value: 'cs', code: 'cs', label: 'Czech', nativeName: 'Czech' },
  { value: 'da', code: 'da', label: 'Danish', nativeName: 'Danish' },
  { value: 'nl', code: 'nl', label: 'Dutch', nativeName: 'Dutch' },
  {
    value: 'et_EE',
    label: 'Estonian (Estonia)',
    code: 'et_EE',
    nativeName: 'Estonian (Estonia)'
  },
  { value: 'fi_FI', code: 'fi_FI', label: 'Finnish', nativeName: 'Finnish' },
  {
    value: 'fr',
    code: 'fr',
    label: 'French',
    nativeName: 'français, langue française'
  },
  {
    value: 'fr-ca',
    code: 'fr_CA',
    label: 'French (Canada)',
    nativeName: 'français, langue canada'
  },
  { value: 'de', code: 'de_DE', label: 'German', nativeName: 'Germany' },
  { value: 'hu', code: 'hu', label: 'Hungarian', nativeName: 'Hungarian' },
  { value: 'it', code: 'it', label: 'Italian', nativeName: 'Italian' },
  {
    value: 'ko_KR',
    code: 'ko_KR',
    label: 'Korean (South Korea)',
    nativeName: 'Korean'
  },
  { value: 'lv', code: 'lv', label: 'Latvian', nativeName: 'Latvian' },
  { value: 'lt', code: 'lt', label: 'Lithuanian', nativeName: 'Lithuanian' },
  {
    value: 'mk_MK',
    code: 'mk_MK',
    label: 'Macedonian',
    nativeName: 'Macedonian'
  },
  {
    value: 'nb_NO',
    code: 'nb_NO',
    label: 'Norwegian Bokmål',
    nativeName: 'Norwegian'
  },
  { value: 'pl', code: 'pl', label: 'Polish', nativeName: 'Polish' },
  { value: 'pt', code: 'pt', label: 'Portuguese', nativeName: 'Português' },
  {
    value: 'pt-br',
    code: 'pt_BR',
    label: 'Portuguese (Brazil)',
    nativeName: 'Português (brasil)'
  },
  { value: 'ro', code: 'ro', label: 'Romanian', nativeName: 'Romanian' },
  { value: 'sr', code: 'sr', label: 'Serbian', nativeName: 'Serbian' },
  { value: 'sk', code: 'sk', label: 'Slovak', nativeName: 'Slovak' },
  { value: 'sl', code: 'sl', label: 'Slovenian', nativeName: 'Slovenian' },
  { value: 'es', code: 'es', label: 'Spanish', nativeName: 'Spanish' },
  { value: 'sv', code: 'sv', label: 'Swedish', nativeName: 'Swedish' }
];
